import { registerPlugin } from '@capacitor/core';
const FeelNative = registerPlugin('FeelNative', {
    web: () => import('./web').then((m) => new m.FeelNativeWeb()),
});
export * from './definitions';
export { FeelNative };
//# sourceMappingURL=index.js.map